module.exports = __webpack_public_path__ + "img/bag.14115823.svg";